'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

/* Views */
var List = require('./list')

var PageReports = function () {
  /* Routes ----------------------------------------------------------------- */
  var Router = App.PermissionAppRouter.extend({
    appRoutes: {
      'reports': 'list'
    }
  })

  /* API -------------------------------------------------------------------- */
  var API = {
    list: function () {
      var list = new List()
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('page-devices:list', function (options) {
    API.list()
  })

  new Router({ controller: API })
}

module.exports = PageReports



// WEBPACK FOOTER //
// ./js/modules/page-reports/index.js